import { useEffect } from "react";
import Lenis from "lenis";

let lenisInstance = null;

export const useLenis = () => {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.1,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    lenisInstance = lenis;
    if (typeof window !== "undefined") window.__lenis = lenis;

    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);

    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      lenisInstance = null;
    };
  }, []);
};

export const scrollToSection = (href) => {
  const target = document.querySelector(href);
  if (!target) return;
  if (lenisInstance) {
    lenisInstance.scrollTo(target, { offset: -80 });
  } else {
    target.scrollIntoView({ behavior: "smooth" });
  }
};
